import { Box } from "@material-ui/core";
import { LoadingWidget } from "src/components/";
import DragAndDrop from "Components/formControls/HookFields/DragAndDrop";
import PhotoSelector from "Components/formControls/HookFields/PhotoSelector";
import { get } from "lodash";
import React, { memo, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { getBase64File } from "src/utils";
import useStyles from "../styles";

const Logo = memo(() => {
  const { t } = useTranslation();
  const [dragLoader, setDragLoader] = useState(false);
  const {
    watch,
    register,
    control,
    setValue,
    setError,
    formState: { errors },
  } = useFormContext();
  const classes = useStyles();

  const { information, disabledView } = watch();
  const [unsplashModal, setUnsplashModal] = useState(false);
  const [unsplashModalLoader] = useState(false);
  const [isUploading] = useState(false);
  const [selectedField, setSelectedField] = useState();
  const uploadUserImage = async (file) => {
    setDragLoader(true);
    await getBase64File(file, setValue, "information.displayUrl");
    setDragLoader(false);
  };
  return (
    <Box>
      {information?.displayUrl ? (
        <Box className={classes.displayUrl} p={2}>
          <Box className={classes.imgWrapper} height="100%" width="100%" p={2}>
            <img
              className={classes.logoDisplay}
              src={information?.displayUrl}
              width={"100%"}
              height={"100%"}
              alt="Logo"
            />
          </Box>
          <Box className={disabledView ? classes.disableLogo : ""}>
            <PhotoSelector
              hideUnsplash={true}
              name="logo"
              setUnsplashModal={setUnsplashModal}
              loading={isUploading}
              unsplashModal={unsplashModal}
              selectedField={selectedField}
              setSelectedField={setSelectedField}
              unsplashModalLoader={unsplashModalLoader}
              uploadUserImage={uploadUserImage}
            />
          </Box>
        </Box>
      ) : (
        <Box className={classes.uploadLogo}>
          <Controller
            register={register(`information.displayUrl`)}
            name={`information.displayUrl`}
            control={control}
            render={({ field }) => {
              const { value } = field;
              return (
                <DragAndDrop
                  loading={dragLoader}
                  //   className={classes.uploadLogo}
                  setError={setError}
                  name={`information.displayUrl`}
                  {...register}
                  onChange={(files) => {
                    if (files.length) {
                      // }
                      uploadUserImage(files[0]);
                    }
                  }}
                  dropzoneText={
                    dragLoader ? (
                      <Box
                        // className={classes.dropzoneLoader}
                        display="flex"
                        width="100%"
                        height="100%"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <LoadingWidget color="grey" />
                      </Box>
                    ) : (
                      t("createTarget.details.coverImage.dragAndDrop.label")
                    )
                  }
                  // dropzoneText={t(
                  //   "createTarget.details.information.dragAndDrop.label"
                  // )}
                  value={value}
                  acceptedFiles={["image/*"]} //, "video/*"
                  filesLimit={1}
                  showDeletButton={true}
                  error={get(errors, "information.displayUrl.message", "")}
                />
              );
            }}
          />
        </Box>
      )}
    </Box>
  );
});

export default Logo;
